import { $tag, TaggedEnumUnion, tagEnum } from '@suntex.core/types';

import { buildStaticContext } from '../utils';

const $ = 'GoalsIndexPhase';

export const GoalsIndexPhase = {
  Early: tagEnum($, 1),
  Elementary: tagEnum($, 2),
  Intermediate: tagEnum($, 3),
  Advanced: tagEnum($, 4),
} as const;

export type GoalsIndexPhase = TaggedEnumUnion<typeof GoalsIndexPhase>;

export const $GoalsIndexPhase = buildStaticContext({
  [$tag]: $,
  [GoalsIndexPhase.Early]: {
    value: GoalsIndexPhase.Early,
    slug: 'early',
    label: 'Early',
  },
  [GoalsIndexPhase.Elementary]: {
    value: GoalsIndexPhase.Elementary,
    slug: 'elementary',
    label: 'Elementary',
  },
  [GoalsIndexPhase.Intermediate]: {
    value: GoalsIndexPhase.Intermediate,
    slug: 'intermediate',
    label: 'Intermediate',
  },
  [GoalsIndexPhase.Advanced]: {
    value: GoalsIndexPhase.Advanced,
    slug: 'advanced',
    label: 'Advanced',
  },
} as const);
